import {
  CERT_LIST_GLOBAL_ERROR,
  SET_CERT_GLOBAL_DATE_FORMAT,
  SET_CERT_LIST_CAMPAIGNKEY,
  SET_CERT_LIST_GLOBAL_LOADING,
  SET_CERT_LIST_IS_WITHOUT_CAMPAIGN_KEY,
  SET_CERTS_TIME_ZONE,
  SET_TOUCH_DEVICE_STATUS,
  UPDATE_SCREEN_SIZE,
} from '../types';

export const setListCampaignKey = (key) => (dispatch) => {
  dispatch({
    type: SET_CERT_LIST_CAMPAIGNKEY,
    payload: key,
  });
};

export const updateScreenSize = (newLabel) => (dispatch, getState) => {
  const currentLabel =
    getState().certifications.details.global?.mediaQueryValue;

  if (newLabel !== currentLabel)
    dispatch({
      type: UPDATE_SCREEN_SIZE,
      payload: newLabel,
    });
};

export const updateTouchDevice = (state) => (dispatch) => {
  dispatch({
    type: SET_TOUCH_DEVICE_STATUS,
    payload: state,
  });
};

export const setGlobalDateFormat = (dateFormat) => (dispatch) => {
  dispatch({
    type: SET_CERT_GLOBAL_DATE_FORMAT,
    payload: dateFormat,
  });
};

export const setListTimeZone = (zone) => (dispatch) => {
  dispatch({
    type: SET_CERTS_TIME_ZONE,
    payload: zone,
  });
};

export const setIsWithoutCampaignKey = (isPinned) => (dispatch) => {
  dispatch({
    type: SET_CERT_LIST_IS_WITHOUT_CAMPAIGN_KEY,
    payload: isPinned,
  });
};

export const setGlobalLoading = (isLoading) => (dispatch) => {
  dispatch({
    type: SET_CERT_LIST_GLOBAL_LOADING,
    payload: isLoading,
  });
};

export const setGlobalError =
  ({ isError, error }) =>
  (dispatch) => {
    dispatch({
      type: CERT_LIST_GLOBAL_ERROR,
      payload: {
        isError,
        error,
      },
    });
  };
